import { render } from "./Mypage.vue?vue&type=template&id=f73c137c&scoped=true"
import script from "./Mypage.vue?vue&type=script&lang=js"
export * from "./Mypage.vue?vue&type=script&lang=js"

import "./Mypage.vue?vue&type=style&index=0&id=f73c137c&scoped=true&lang=css"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73c137c"]])

export default __exports__